import { ReportSection, WarningFooter } from '@/reports/index';
import { peopleTypes } from '@/reports/types';
import { Table, useTheme } from '@/theme/index';
import { getDatesAttended, titleize } from '@/utils/index';
import { useScreenSize } from '@/utils/useScreenSize';
import { MobileEducationRow } from './MobileEducationRow';

export interface ContactEducationSectionProps {
  /** Number of educations. */
  educationsCount: number;
  /** The name of the person. */
  personName: string;
  /** The list of educations. */
  educationList: peopleTypes.Educations;
}

/**
 * Represents the education section in the contact report.
 */
export function ContactEducationSection({
  educationsCount,
  personName,
  educationList,
}: ContactEducationSectionProps) {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  const headers = ['School', 'Degree', 'Dates Attended'];

  const tableStyles = {
    marginTop: theme.spacing(1.25),
    boxShadow: '0px 1px 0px rgb(0 0 0 / 15%)',
  };

  return (
    <ReportSection
      title="Possible Education"
      sectionId="education-section"
      hasContent={educationsCount > 0}
      personName={personName}
      FooterComponent={<WarningFooter />}
    >
      {isMobile ? (
        educationList.map((education, index) => (
          <MobileEducationRow key={index} education={education} />
        ))
      ) : (
        <Table
          headers={headers}
          rows={educationList.map((education) => [
            titleize(education.school || '', { lowercase: true }) || '',
            education.degree || '-',
            getDatesAttended(education, true) || '-',
          ])}
          className="striped"
          headerRowStyle={{
            backgroundColor: theme.palette.primary.main,
            padding: theme.spacing(1.25, 2),
            color: theme.palette.common.white,
            fontSize: '1rem',
            fontWeight: theme.typography.fontWeightBold,
          }}
          bodyRowStyle={{
            '.MuiTableCell-body': {
              padding: theme.spacing(1.25, 2),
              fontSize: '1rem',
            },
          }}
          sx={tableStyles}
        />
      )}
    </ReportSection>
  );
}
